import React from 'react';
import {useTasksOfflineAutoSession} from './offline/tasksSession';

export interface TasksOfflineBoundaryProps {
  children: React.ReactNode;
}

// Wraps the task and action pages so the auto-cached offline session starts once
// the user is signed in, whichever of those pages they land on first.
export const TasksOfflineBoundary: React.FC<TasksOfflineBoundaryProps> = ({
  children,
}) => {
  useTasksOfflineAutoSession();
  return <>{children}</>;
};
